import React from 'react';
import { Button, Container, Form, InputGroup, Label, Row } from 'reactstrap';
import { Field, Fields } from 'redux-form';
import { LinkContainer } from 'react-router-bootstrap';
import { compact, omit, pick } from 'underscore';
import URI from 'urijs';
import cx from 'classnames';

// components
import { ucFirst } from '../../../utilities';
import { cleanQuery } from '../../../middleware/client';
import PriceFilter from '../../../components/form/filter/price-filter';
import { LocationTypeAheadField } from '../../../components/form/field/location-typeahead';
import BuildingTypeFilter from '../../../components/form/filter/building-type-filter';
import StatusFilter from '../../../components/form/filter/status-filter';

import fieldButtonDropdown from '../../../decorators/field-button-dropdown';

// modules
import BS from '../../../theme/Bootstrap';
import styles from '../../Containers.module.scss';

const PriceDropdown = fieldButtonDropdown(PriceFilter);
const BuildingTypeDropdown = fieldButtonDropdown(BuildingTypeFilter);
const StatusDropdown = fieldButtonDropdown(StatusFilter);

const RentalSearch = props => {
  const { handleSubmit, /*onFilterClick,*/ initialValues, basePath } = props;
  const allValues = cleanQuery(omit(initialValues, 'view', 'agentId', 'propertyClass'));
  const advancedOnlyValues = omit(
    allValues,
    'address',
    'minPrice',
    'maxPrice',
    'status',
    'buildingType',
    'minGrossIncome',
    'maxGrossIncome'
  );
  const moreClassName = cx({
    'badge-dirty': Object.keys(advancedOnlyValues).length > 0
  });
  const resetClassName = cx({
    'badge-dirty': Object.keys(allValues).length > 0
  });
  const propertyClass = initialValues.propertyClass || 'residential';

  return (
    <Row
      className={cx(
        styles.searchHeader,
        BS.pt3,
        styles['searchHeader' + ucFirst(propertyClass)]
      )}
    >
      <Container>
        <Form inline className={cx(BS.alignItemsStart)} onSubmit={handleSubmit}>
          {props.children}
          <InputGroup className={cx(BS.inputGroupGutter, BS.pb2, BS.mrSm2)}>
            <Label for="address" className="sr-only">
              Address, City, Neighborhood, Zip
            </Label>
            <LocationTypeAheadField
              propertyClass="residential_income"
              showSubmit
              submitClassName={cx(BS.ml2)}
            />
          </InputGroup>
          <InputGroup className={cx(BS.inputGroupGutter, BS.pb2)}>
            <LinkContainer
              to={URI(`${basePath}/advanced`)
                .search(cleanQuery(initialValues))
                .toString()}
            >
              <Button color="dark-blue" outline className={cx(moreClassName, BS.dMdNone)}>
                Filters
              </Button>
            </LinkContainer>
          </InputGroup>
          <InputGroup className={cx(BS.inputGroupGutter, BS.dNone, BS.dSmFlex, BS.pb2)}>
            <Fields
              names={['minPrice', 'maxPrice']}
              component={PriceDropdown}
              label="Price"
              showSelects
              type="residential_income"
            />
            <Field
              name="status"
              component={StatusDropdown}
              type="residential_income"
              label="Status"
              className={BS.w50}
            />
            <Field
              name="buildingType"
              format={value => {
                return compact((value || '').trim().split(','));
              }}
              normalize={value => {
                return value.join(',');
              }}
              component={BuildingTypeDropdown}
              type="residential_income"
              label="Building Type"
              numCols={2}
              numInnerCols={1}
            />
            <Fields
              names={['minGrossIncome', 'maxGrossIncome']}
              component={PriceDropdown}
              label="Gross Income"
            />
            <LinkContainer
              to={URI(`${basePath}/advanced`)
                .search(cleanQuery(initialValues))
                .toString()}
            >
              <Button color="white" className={moreClassName}>
                More Filters
              </Button>
            </LinkContainer>
            <LinkContainer
              to={URI(`${basePath}`)
                .search({
                  ...pick(initialValues, 'view', 'pageSize'),
                  propertyClass:
                    propertyClass !== 'residential' ? propertyClass : undefined,
                  page: 1
                })
                .toString()}
            >
              <Button color="white-red" className={resetClassName}>
                Reset Filters
              </Button>
            </LinkContainer>
          </InputGroup>
        </Form>
      </Container>
    </Row>
  );
};

export default RentalSearch;



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/Search/ResidentialIncomeSearch.js